import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private apiClient: ApiClientService) {
  }

  passwordLost(email: string): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post('/password/lost', {}, {email}, {ignoreBadRequest: true}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  passwordCheckKey(key: string): Observable<boolean> {
    return new Observable<boolean>((subscriber: Subscriber<any>): void => {
      this.apiClient.get('/password/check-key/' + key).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['valid']);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  passwordReset(key: string, password: string): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post('/password/reset', {}, {key, password}, {ignoreBadRequest: true}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
